import { heroContent } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20creative%20digital%20content%20creation%20atmosphere%20with%20colorful%20abstract%20geometric%20shapes%20floating%20in%20warm%20orange%20and%20golden%20gradient%20space%2C%20modern%20tech%20feel%20with%20soft%20glowing%20particles%2C%20futuristic%20and%20playful%20aesthetic%2C%20clean%20minimal%20composition%2C%204k%20quality%20render&width=1920&height=1080&seq=hero-bg-2024&orientation=landscape"
        alt="香蕉视频 - 创意短视频平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="hero-overlay"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6 tracking-wide animate-fade-in-up">
          {heroContent.headline}
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-2 md:mb-3 max-w-2xl animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          {heroContent.subheadline}
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-xl mb-6 md:mb-8 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          {heroContent.description}
        </p>
        <div className="flex items-center gap-4 animate-fade-in-up flex-col sm:flex-row" style={{ animationDelay: '0.45s' }}>
          <a
            href="#download"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105"
          >
            {heroContent.ctaPrimary}
          </a>
          <a
            href="#features"
            className="whitespace-nowrap px-8 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300"
          >
            {heroContent.ctaSecondary}
          </a>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-fade-in" style={{ animationDelay: '0.8s' }}>
        <a href="#features" className="text-white/50 hover:text-white/80 transition-colors">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}